import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Recurso } from './../../../entity/Recurso.model';
import { Component, Input } from '@angular/core';
import { BaseStepComponent } from '../../../base';
import { SelectItem } from 'primeng/primeng';
import { TipoPosGraduacao } from 'app/entity/enumeraveis';

@Component({
  selector: 'gerenciamanento-pos-graduacao-etapa2',
  templateUrl: './etapa2.component.html'
})
export class GerenciamentoPosGraduacaoEtapa2Component extends BaseStepComponent {

  @Input() gerenciamentoPosGraduacao: any;
  @Input() acao: string;
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() listaDadosInstituicao: SelectItem[];
  @Input() listaTipoAtividade: SelectItem[];
  @Input() mostrarCodigo: boolean;
  @Input() listaTipoPosGraduacao: SelectItem[];
  @Input() listaArea: SelectItem[];
  @Input() listaPntCFC: any[] = [];
  @Input() listaPntCRC: any[] = [];
  @Input() etapaHomologacao = 3;
  @Input() controladorGerenciamento = true;
  @Input() mostrarVisualizacao = true;
  @Input() listaCapacitadora: any[] = [];
  @Input() id: number;
  @Input() recurso: Recurso[] = [];
  @Input() recursoFiltro: RecursoFiltro;
  @Input() decisaoComissaoCrc: any;
  @Input() habilitaCamposPontuacao: boolean;
  @Input() disabledCheckbox: boolean;
  @Input() etapa: number;
  @Input() isHomologacao: boolean;

  tipoPosGraduacao = TipoPosGraduacao;
  displayConteudoModal = false;
  modal_obj: any;

  init() {
    this.toggleLoading(true);

    this.loadData('instituicao', 'listaDadosInstituicao');
    this.loadData('cursoAcademico', 'listaArea');
    this.loadData('natureza', 'listaTipoAtividade', { query: 'Pós Graduação' });

    if (this.id !== undefined) {
      this.loadRecursoData(this.id);
    }

    this.toggleLoading(false);
  }

  private loadData(endpoint: string, listProperty: string, params?: any) {
    if (this[listProperty] == undefined) {
      this.service.ListarTodos(endpoint, params).subscribe(data => {
        this[listProperty] = data;
      });
    }
  }

  private loadRecursoData(id: number) {
    this.service.Obter('gerenciamento-pos-graduacao/recursoList', id).subscribe(item => {
      this.recurso = item;
    });
    this.recursoFiltro.IdModel = id;
  }

  showDialog(obj: any) {
    this.displayConteudoModal = true;
    this.modal_obj = obj;
  }

  private toggleLoading(loading: boolean): void {
    this.observableUtilPanelDoc.setBlockedPanel(loading);
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-pos-graduacao/crud/etapa2/etapa2.component.ts